import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RecommendedComponent} from './recommended.component';
import {CarouselFtdModule} from '../carousel-ftd/carousel-ftd.module';
import {IconsModule} from '../icons/icons.module';
import {ButtonModule} from '../button/button.module';
import {RouterModule} from '@angular/router';
import { ClickOutsideContainerDirective } from '../../directives/click-outside-container.directive';
@NgModule({
  declarations: [
    RecommendedComponent,
    ClickOutsideContainerDirective
  ],
  exports: [RecommendedComponent],
  imports: [
    CommonModule,
    CarouselFtdModule,
    IconsModule,
    ButtonModule,
    RouterModule 
  ],
})
export class RecommendedModule { }
